export const DEV_BASE_URL = 'https://bsc-api.cpf.or.ke';
export const STAGING_BASE_URL = 'https://bsc-api.cpf.or.ke';
// export const PRODUCTION_BASE_URL = "http://bsc-pilot.quantrica.com";
export const PILOT_BASE_URL = 'https://bsc-api.cpf.or.ke';
export const PRODUCTION_BASE_URL = 'https://bsc.cpf.or.ke';

export const PRODUCTION_BASE_API_URL = 'https://bsc-api.cpf.or.ke/api/v1';
export const STAGING_BASE_API_URL = 'https://bsc-api.cpf.or.ke/api/v1';
// export const PRODUCTION_BASE_API_URL =
//   "http://api.bsc-pilot.quantrica.com/api/v1";
export const PILOT_BASE_API_URL = 'https://bsc-api.cpf.or.ke/api/v1';
export const DEV_BASE_API_URL = 'https://bsc-api.cpf.or.ke/api/v1';
export let BASE_URL = '';
export let BASE_API_URL = '';
export const PROFILE_KEY = '__profile__';
export const location = window && window.location;
export const hostname = `${location.protocol}//${location.hostname}`;
switch (hostname) {
  case STAGING_BASE_URL:
    BASE_URL = STAGING_BASE_URL;
    BASE_API_URL = STAGING_BASE_API_URL;
    break;
  case PILOT_BASE_URL:
    BASE_URL = PILOT_BASE_URL;
    BASE_API_URL = PILOT_BASE_API_URL;
    break;
  case PRODUCTION_BASE_URL:
    BASE_URL = PRODUCTION_BASE_URL;
    BASE_API_URL = PRODUCTION_BASE_API_URL;
    break;
  default:
    BASE_URL = `${DEV_BASE_URL}:${location.port}`;
    BASE_API_URL = `${STAGING_BASE_API_URL}`;
    break;
}
